<template>
  <aside class="main" v-if="ready && date && time">
    <div class="content">
      <label class="date">{{ date }}</label>
      <label class="time">{{ time }}</label>
    </div>
  </aside>
</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex';
import Services from '../mixins/services';
import moment from "moment";

export default {
  mixins: [Services],
  props: {
    clinicId: {
      type: String,
      required: true,
    },
    dealerId: {
      type: String,
      required: true,
    }
  },
  data: function () {
    return {
      ready: false,
      date: null,
      time: null
    }
  },
  computed: mapState({
    clientToken: state => state.ClientToken.clientToken,
    nextAvailableAppointment: state => state.NextAvailable.nextAvailableAppointment,
  }),
  methods: {
    ...mapActions('ClientToken', {getClientToken: 'getClientToken'}),
    ...mapActions('NextAvailable', {getInformation: 'getInformation'}),
  },
  mounted() {
    this.getClientToken({
      cb: () => {
        this.getInformation({
          clinicId: this.clinicId,
          dealerId: this.dealerId,
          clientToken: this.clientToken,
          cb: () => {
            if (this.nextAvailableAppointment !== '0001-01-01T00:00:00') {
              this.date = moment(this.nextAvailableAppointment).format("dddd MMM. Do");
              this.time = moment(this.nextAvailableAppointment).format("h:mm A");
              this.ready = true;
            }
          }
        });
      }
    })
  }
}
</script>